





















import Vue from 'vue';

export default Vue.extend({
  props: {
    icon: {
      default: null,
      type: String,
    },
    iconBehind: {
      default: false,
      type: Boolean,
    },
    link: {
      default: null,
      type: String,
    },
    title: {
      default: null,
      type: String,
    },
  },
  methods: {
    clicked(): void {
      this.$emit(`click`);
    },
  },
});
